(function () {
    App.directive('healthFormTypeSelect', healthFormTypeSelectDirective);
    healthFormTypeSelectDirective.$inject = ['Config'];

    function healthFormTypeSelectDirective(Config) {
        return {
            restrict: 'E',
            scope: {
                list: '<',
                change: '&'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/health-form-type-select.html',
            controller: HealthFormTypeSelect,
            controllerAs: '$ctrl',
            bindToController: true
        };
    }
    
    HealthFormTypeSelect.$inject = [];
    
    function HealthFormTypeSelect() {
        var self = this;
        self.selectedItem = null;

        self.selectItem = function (item) {
            if (self.selectedItem && self.selectedItem.id === item.id) {
                self.selectedItem = null;
            } else {
                self.selectedItem = item;
            }

            self.change && self.change({$event: self.selectedItem});
        }
    }
})();
